interface IProps {
  title: string;
  className?: string;
}
const GuideMeTitleBar: React.FC<IProps> = ({
  title,
  className = 'font-bold text-xl text-red-600',
}) => (
  <div className={className}>
    <span>{title}</span>
  </div>
);

export default GuideMeTitleBar;
